import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

const SubHospitalDetails = () => {
  const { subHospitalId } = useParams();
  const [subHospital, setSubHospital] = useState(null);

  useEffect(() => {
    const fetchSubHospitalDetails = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/subHospitals/${subHospitalId}`,
        );
        setSubHospital(response.data);
      } catch (error) {
        console.error('Error fetching sub-hospital details:', error);
      }
    };

    fetchSubHospitalDetails();
  }, [subHospitalId]);

  if (!subHospital) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h2>{subHospital.sub_hospital_name}</h2>
      <p>
        <strong>Location:</strong> {subHospital.location}
      </p>
      <p>
        <strong>Hospital ID:</strong> {subHospital.hospital_id}
      </p>
      {/* Add components or sections to handle doctors and receptionists */}
    </div>
  );
};

export default SubHospitalDetails;
